"use strict";

var _regeneratorRuntime = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;

var Container_1 = require("./Container");

var Utils_1 = require("../Utils");

var tsParticlesDom = [];

function fetchError(statusCode) {
  console.error("Error tsParticles - fetch status: ".concat(statusCode));
  console.error("Error tsParticles - File config not found");
}

var Loader =
/*#__PURE__*/
function () {
  function Loader() {
    _classCallCheck(this, Loader);
  }

  _createClass(Loader, null, [{
    key: "dom",
    value: function dom() {
      return tsParticlesDom;
    }
  }, {
    key: "domItem",
    value: function domItem(index) {
      var dom = Loader.dom();
      var item = dom[index];

      if (item && !item.destroyed) {
        return item;
      }

      dom.splice(index, 1);
    }
  }, {
    key: "loadOptions",
    value: function () {
      var _loadOptions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(params) {
        var _a, _b, _c, tagId, options, index, domContainer, currentOptions, dom, oldIndex, old, canvasEl, generatedCanvas, existingCanvases, newItem;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tagId = (_a = params.tagId) !== null && _a !== void 0 ? _a : "tsparticles".concat(Math.floor(Math.random() * 10000));
                options = params.options, index = params.index;
                domContainer = (_b = params.element) !== null && _b !== void 0 ? _b : document.getElementById(tagId);

                if (!domContainer) {
                  domContainer = document.createElement("div");
                  domContainer.id = tagId;
                  (_c = document.querySelector("body")) === null || _c === void 0 ? void 0 : _c.append(domContainer);
                }

                currentOptions = options instanceof Array ? (0, Utils_1.itemFromArray)(options, index) : options;
                dom = Loader.dom();
                oldIndex = dom.findIndex(function (v) {
                  return v.id === tagId;
                });

                if (oldIndex >= 0) {
                  old = Loader.domItem(oldIndex);

                  if (old && !old.destroyed) {
                    old.destroy();
                    dom.splice(oldIndex, 1);
                  }
                }

                if (domContainer.tagName.toLowerCase() === "canvas") {
                  canvasEl = domContainer;
                  generatedCanvas = false;
                } else {
                  existingCanvases = domContainer.getElementsByTagName("canvas");

                  if (existingCanvases.length) {
                    canvasEl = existingCanvases[0];

                    if (!canvasEl.className) {
                      canvasEl.className = Utils_1.Constants.canvasClass;
                    }

                    generatedCanvas = false;
                  } else {
                    generatedCanvas = true;
                    canvasEl = document.createElement("canvas");
                    canvasEl.className = Utils_1.Constants.canvasClass;
                    canvasEl.style.width = "100%";
                    canvasEl.style.height = "100%";
                    domContainer.appendChild(canvasEl);
                  }
                }

                newItem = new Container_1.Container(tagId, currentOptions);

                if (oldIndex >= 0) {
                  dom.splice(oldIndex, 0, newItem);
                } else {
                  dom.push(newItem);
                }

                newItem.canvas.loadCanvas(canvasEl, generatedCanvas);
                _context.next = 14;
                return newItem.start();

              case 14:
                return _context.abrupt("return", newItem);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadOptions(_x) {
        return _loadOptions.apply(this, arguments);
      }

      return loadOptions;
    }()
  }, {
    key: "loadRemoteOptions",
    value: function () {
      var _loadRemoteOptions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(params) {
        var jsonUrl, index, url, response, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                jsonUrl = params.url, index = params.index;
                url = jsonUrl instanceof Array ? (0, Utils_1.itemFromArray)(jsonUrl, index) : jsonUrl;

                if (url) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return fetch(url);

              case 6:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 10;
                  break;
                }

                fetchError(response.status);
                return _context2.abrupt("return");

              case 10:
                _context2.next = 12;
                return response.json();

              case 12:
                data = _context2.sent;
                _context2.next = 15;
                return Loader.loadOptions({
                  tagId: params.tagId,
                  element: params.element,
                  index: index,
                  options: data
                });

              case 15:
                return _context2.abrupt("return", _context2.sent);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadRemoteOptions(_x2) {
        return _loadRemoteOptions.apply(this, arguments);
      }

      return loadRemoteOptions;
    }()
  }, {
    key: "load",
    value: function load(tagId, options, index) {
      var params = {
        index: index
      };

      if (typeof tagId === "string") {
        params.tagId = tagId;
      } else {
        params.options = tagId;
      }

      if (typeof options === "number") {
        params.index = options !== null && options !== void 0 ? options : params.index;
      } else {
        params.options = options !== null && options !== void 0 ? options : params.options;
      }

      return this.loadOptions(params);
    }
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(id, domContainer, options, index) {
        var params;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  index: index
                };

                if (typeof id === "string") {
                  params.tagId = id;
                } else {
                  params.element = id;
                }

                if (domContainer instanceof HTMLElement) {
                  params.element = domContainer;
                } else {
                  params.options = domContainer;
                }

                if (typeof options === "number") {
                  params.index = options;
                } else {
                  params.options = options !== null && options !== void 0 ? options : params.options;
                }

                return _context3.abrupt("return", this.loadOptions(params));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function set(_x3, _x4, _x5, _x6) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "loadJSON",
    value: function () {
      var _loadJSON = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(tagId, jsonUrl, index) {
        var url, id;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (typeof jsonUrl === "number" || jsonUrl === undefined) {
                  url = tagId;
                } else {
                  id = tagId;
                  url = jsonUrl;
                }

                _context4.next = 3;
                return Loader.loadRemoteOptions({
                  tagId: id,
                  url: url,
                  index: index
                });

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadJSON(_x7, _x8, _x9) {
        return _loadJSON.apply(this, arguments);
      }

      return loadJSON;
    }()
  }, {
    key: "setJSON",
    value: function () {
      var _setJSON = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(id, domContainer, jsonUrl, index) {
        var url, newId, newIndex, element;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (id instanceof HTMLElement) {
                  element = id;
                  url = domContainer;
                  newIndex = jsonUrl;
                } else {
                  newId = id;
                  element = domContainer;
                  url = jsonUrl;
                  newIndex = index;
                }

                _context5.next = 3;
                return Loader.loadRemoteOptions({
                  tagId: newId,
                  url: url,
                  index: newIndex,
                  element: element
                });

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setJSON(_x10, _x11, _x12, _x13) {
        return _setJSON.apply(this, arguments);
      }

      return setJSON;
    }()
  }, {
    key: "setOnClickHandler",
    value: function setOnClickHandler(callback) {
      var dom = Loader.dom();

      if (dom.length === 0) {
        throw new Error("Can only set click handlers after calling tsParticles.load() or tsParticles.loadJSON()");
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = dom[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var domItem = _step.value;
          domItem.addClickHandler(callback);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);

  return Loader;
}();

exports.Loader = Loader;